import { useBerichtenPakkettenMetProlongatieInfoOphalen } from '@services/communicatie-public/orval-api/berichten-api/berichten-api';
import { computed, type MaybeRefOrGetter } from 'vue';
import { useRouteRelatienummer } from './route-relatienummer';

export function usePakketten(options?: { enabled?: MaybeRefOrGetter<boolean | undefined> }) {
  const relatienummer = useRouteRelatienummer();

  return useBerichtenPakkettenMetProlongatieInfoOphalen(
    computed(() => ({
      relatienummer: relatienummer.value,
    })),
    {
      query: {
        ...options,
        select: ({ result }) => result,
      },
    },
  );
}
